import { render, staticRenderFns } from "./WBjh.vue?vue&type=template&id=602bde5e&scoped=true"
import script from "./WBjh.vue?vue&type=script&lang=js"
export * from "./WBjh.vue?vue&type=script&lang=js"
import style0 from "./WBjh.vue?vue&type=style&index=0&id=602bde5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602bde5e",
  null
  
)

export default component.exports